import React from "react";
import ContactTabs from "../../../components/ContactTab/ContactTabWidget";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

import ContactUsCustomerSupport from "../ContactUsCustomerSupport/ContactUsCustomerSupport";
import ContactUsReportFraud from "../ContactUsReportFraud/ContactUsReportFraud";
import ContactUsMerchantSupport from "../ContactUsMerchantSupport/ContactUsMerchantSupport";
import ContactUsEthicsConcern from "../ContactUsEthicsConcern/ContactUsEthicsConcern";

import "./ContactUsTabWidget.css";
class ContactUsTabWidget extends React.Component {
    render() {
        return (
            <WidgetContainer stylesClass="tabs-wc">
                <ContactTabs>
                    <div label="Customer Support">
                        <ContactUsCustomerSupport />
                    </div>
                    <div label="Report Fraud">
                        <ContactUsReportFraud />
                    </div>
                    <div label="Merchant Support">
                        <ContactUsMerchantSupport />
                    </div>
                    <div label="Report Ethics Concerns">
                        <ContactUsEthicsConcern />
                    </div>
                </ContactTabs>
                <div className="cu-tab-widget"></div>
            </WidgetContainer>
        );
    }
}

export default ContactUsTabWidget;
